// Field — label + optional counter + children wrapper used across the
// publish modal. Extracted from PublishAnalysisModal.jsx (P2 refactor).
import React from "react";

export const Field = ({ label, counter, counterColor, required, children }) => (
  <div className="mt-3">
    <div className="mb-1.5 flex items-center justify-between">
      <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/45">
        {label}{required && <span className="text-orange-300"> *</span>}
      </span>
      {counter && (
        <span
          className="text-[10px] transition-colors"
          style={{ color: counterColor || "rgba(255,255,255,0.35)" }}
        >
          {counter}
        </span>
      )}
    </div>
    {children}
  </div>
);

export default Field;
